import $ from 'jquery';
import './vendor/jquery.flexslider-min.js';

$(window).load(function() {

	// initialize slider
    $('.flexslider').flexslider({
		slideshowSpeed: 3000,
		start: function(){
	        $('.flexslider img').show();
	    },
    });

    var iScrollPos = 0,
		topBar = $('#top-bar');

	// show top bar after scrolling past header
	new Waypoint({
		element: document.getElementById('section1'),
		handler: function(direction) {
		  	if (direction == 'down') {
		    	topBar.show();
		    } else {
				topBar.hide();
		    }
		},
	});

    // hide top bar once scrolled down to form
    new Waypoint({
        element: document.getElementById('get-started'),
        handler: function(direction) {
            if (direction == 'down') {
                topBar.hide();
            } else {
                topBar.show();
            }
        },
    });
});

// hubspot form - check if email address submitted is already a member based on domain
$('body').on('blur', '#get-started .hs-form input[type="email"]', function() {

    var form = $(this).closest('form'),
        emailAddress = $(this).val(),
        apiUrl = '/wp-json/btp-hubspot-contacts-sync/v1/domain-check',
        submitBtn = $(this).closest('form').find('input[type="submit"]'),
        submitBtnText = submitBtn.val();

    if (isValidEmailAddress(emailAddress)) {
        submitBtn.prop('disabled', true);
        submitBtn.val('Verifying...');
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: apiUrl,
            data: {email: emailAddress, listId: '689'},
            success: function(data) {
                if (data.success){
                    // check against CableLabs HubSpot member list
                    // list id can be found at the end of the HubSpot list URL, e.g. https://app.hubspot.com/lists/1697621/list/689
                    // user is already a member, notify user
                    $('#get-started .default').fadeOut('slow', function() {
                        $('#get-started .register').fadeIn('slow');
                    });
                }
                submitBtn.prop('disabled', false);
                submitBtn.val(submitBtnText);
            },
            // fallback in case database table check fails
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                submitBtn.prop('disabled', false);
                submitBtn.val(submitBtnText);
            }
        });
    }
});

function isValidEmailAddress(emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
}
